import axios from "axios";
import { loginreq, req, reqPost } from "./axiosFun";


//广告管理
export const addBannerAPi = params => {
    return req("post", "/app-yijiu-backstage/addAdvertisement", params);
};
// 查看广告 
export const bannerInfoAPi = params => {
    return req("get", "/app-yijiu-backstage/getAdminAdvertisementInfo", params);
};
// 修改广告 
export const editBannerAPi = params => {
    return req("post", "/app-yijiu-backstage/upAdvertisement", params);
};
// 删除广告
export const delBannerAPi = params => {
    return req("get", "/app-yijiu-backstage/deleteAdvertisement", params);
};




// WEBPACK FOOTER //
// ./src/api/banner_admin.js